import React from 'react';
import { PiTrashDuotone } from 'react-icons/pi';
import { Button } from 'rizzui';
import ControlledInput from '../../../components/forms/ControlledInput';
import CustomSelect from '../../../components/forms/CustomSelect';
import { FilterOptions } from '../../../hooks/useFilters';

interface RankingsFiltersProps {
    updateFilters: (filters: any) => void;
    resetFilters: (limit: any) => void;
    filters: FilterOptions;
}

const resetIntervalOptions = [
    { label: 'Todos', value: 'null' },
    { label: 'Diario', value: 'daily' },
    { label: 'Semanal', value: 'weekly' },
    { label: 'Mensual', value: 'monthly' },
    { label: 'Personalizado', value: 'custom' },
];

const RankingsFilters: React.FC<RankingsFiltersProps> = ({ filters, updateFilters, resetFilters }) => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 p-4 bg-white rounded-lg shadow-sm border border-gray-200 mb-2">
            <div className="space-y-1">
                <ControlledInput
                    id='search_text'
                    type="text"
                    label="Buscar por nombre"
                    placeholder="Nombre del ranking..."
                    className="[&>label>span]:font-medium"
                    inputClassName="text-sm"
                    onChange={(value: string) => updateFilters({ search_text: value })}
                    value={filters.filter_filters?.search_text || ''}
                    debounceMs={500}
                />
            </div>

            <div className="space-y-1">
                <CustomSelect
                    isSearchable
                    id={'reset_interval'}
                    label="Tipo de ranking"
                    placeholder="Seleccionar tipo..."
                    options={resetIntervalOptions}
                    onChange={(e: any) => {
                        if (e.value === 'null') {
                            updateFilters({ reset_interval: null });
                            return;
                        }
                        updateFilters({ reset_interval: e.value });
                    }}
                    value={filters.filter_filters?.reset_interval !== null && filters.filter_filters?.reset_interval !== undefined
                        ? resetIntervalOptions.find(option => option.value === filters.filter_filters?.reset_interval)
                        : resetIntervalOptions[0]}
                />
            </div>

            <div className="flex items-end">
                <Button
                    size="sm"
                    onClick={() => {
                        resetFilters(50);
                    }}
                    variant="flat"
                    className="h-9 bg-gray-200/70 hover:bg-gray-300/70 transition-colors w-full"
                >
                    <PiTrashDuotone className="me-1.5 h-[17px] w-[17px]" /> Limpiar
                </Button>
            </div>
        </div>
    );
};

export default RankingsFilters;